import EvaluationsScreen from './EvaluationsScreen.js';

export default EvaluationsScreen;
